import React from 'react';
import {Route} from 'react-router-dom';

import Dashboard from './Fuse/dashboard';
import NoAccess from './Fuse/noAccess';
import {SystemsReportContainer} from './Fuse/Report/SystemsReportContainer';

export default [

    <Route exact path="/System" component={Dashboard}/>,
    <Route exact path="/SystemsReport" component={SystemsReportContainer}/>,
    <Route exact path="/NoAccess" component={NoAccess}/>,

];



// WEBPACK FOOTER //
// ./src/routes.js